/* eslint-disable */
import ApiService from '@/common/api.service';

const getDefaultState = () => {
  return {
    selectedMode: 'ADMIXTURE',
  }
}

const state = getDefaultState()

const getters = {
}

const mutations = {
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
